// This will only render in the theme editor
if (Shopify?.designMode) {
  let timesRun = 0;

  function fixSectionWrappers() {
    // get all of the sections that have a [data-shopify-id}]
    const sections = document.querySelectorAll("[data-shopify-id]");
    // loop over each section
    sections?.forEach((section) => {
      // check if it has a parent of type div
      if (section.parentElement.tagName === "DIV") return;

      // if it doesn't, wrap it in a div with the id of the section and class of shopify section
      const wrapper = document.createElement("div");
      // add the [data-shopify-id] of the section to the wrapper as an id
      wrapper.id = `shopify-section-${section.dataset.shopifyId}`;
      wrapper.classList.add("shopify-section");
      section.parentElement.insertBefore(wrapper, section);
      wrapper.appendChild(section);
    });

    // check if on a product template
    if (document.querySelector(".template-product")) {
      // find the div with a class of shopify section and an id of shopify-section-template--{some number}__main
      // regex to find the id of the main section
      const mainSection = document.querySelector(".shopify-section[id^='shopify-section-template--'][id$='__main']");
      // get main product section by id main-product__section and wrap it in a div with the id of the section and class of shopify section
      const mainProductSection = document.querySelector("#main-product__section");

      // check if parent element is a div with id root
      if (mainProductSection.parentElement.tagName === "DIV" && mainProductSection.parentElement.id !== "root") return;

      // if not, wrapp it up the way Shopify likes
      const wrapper = document.createElement("div");
      wrapper.id = mainSection.id;
      wrapper.classList.add("shopify-section");
      mainProductSection.parentElement.insertBefore(wrapper, mainProductSection);
      wrapper.appendChild(mainProductSection);
    }

    timesRun++;
  }

  document.addEventListener("shopify:inspector:activate", () => fixSectionWrappers());
  document.addEventListener("shopify:inspector:deactivate", () => fixSectionWrappers());
  document.addEventListener("shopify:section:reorder", () => fixSectionWrappers());
  document.addEventListener("shopify:section:load", () => fixSectionWrappers());
  document.addEventListener("shopify:section:select", () => fixSectionWrappers());
  document.addEventListener("shopify:section:deselect", () => fixSectionWrappers());

  // run the function every 5 seconds until it has run 5 times
  const interval = setInterval(() => {
    if (timesRun >= 5) {
      clearInterval(interval);
    }
    fixSectionWrappers();
  }, 5000);
}
